export const UPDATE_USER = 'UPDATE_USER'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js